import { API, doGet, doPost, doPut, doDelete } from "@/api/api.js"

export default {
    data: function () {
        return {
            initialUrl: "",   //读取数据地址，默认是REST，不填则使用默认设置
            tag: "",          //如：AMDIN、ROLE
            handle: "",       //insert、update、delete
            isHandle: false,  //是否弹窗
            selectRows: [],   //选中的行数（包含行中的完整数据）
            handleInfo: {},   //当前正在操作的信息（insert为{}，update、delete为当前操作项）
            current: 1,
            size: 10,
            total: 0,
            records: [],
            pageMap: [
                { code: "ADDRESS", name: "库存地信息", primaryColumn: "addressId" },
                { code: "ADMIN", name: "管理员信息", primaryColumn: "adminId" },
                { code: "RESALE", name: "代卖信息", primaryColumn: "resaleId" },
                { code: "COIN", name: "钱币字典信息", primaryColumn: "coinId" },
                { code: "CUSTOMER", name: "出品人信息", primaryColumn: "customerId" },
                { code: "GRADE", name: "评级公司信息", primaryColumn: "gradeId" },
                { code: "PRODUCT", name: "钱币信息", primaryColumn: "productId" },
                { code: "CATEGORY", name: "朝代信息", primaryColumn: "categoryId" },
                { code: "CATEGORY_CHILD", name: "朝代子分类", primaryColumn: "categoryChildId" },
                { code: "PERMISSION", name: "权限信息", primaryColumn: "permissionId" },
                { code: "LOCK", name: "我的锁定", primaryColumn: "logId" },
                { code: "OUT", name: "未结算", primaryColumn: "logId" },
                { code: "NOTIFY", name: "系统消息", primaryColumn: "notifyId" },
                { code: "LOG", name: "日志信息", primaryColumn: "logId" },
                { code: "SEND", name: "发货信息", primaryColumn: "sendId" },
                { code: "DOWNLOAD", name: "下载任务", primaryColumn: "downloadId" },
                { code: "BUYER", name: "客户信息", primaryColumn: "buyer" },
                { code: "PRIZE", name: "价格信息", primaryColumn: "productId" },
            ],
            filterParams: {},
            sortParams: {
                prop: "",
                order: ""
            }
        }
    },
    methods: {
        selectRowsChange: function(rows) {
            this.selectRows = rows;
        },
        sortChange: function(sort) {
            this.sortParams.prop = sort.prop;
            this.sortParams.order = sort.order;
            this.initialData();
        },
        sizeChange: function (size) {
            this.size = size;
            this.initialData();
        },
        currentChange: function (current) {
            this.current = current;
            this.initialData();
        },
        initialData: async function () {
            let filterObj = {};
            Object.assign(filterObj, this.filterParams);
            filterObj.current = this.current;
            filterObj.size = this.size;
            if (this.sortParams.prop && this.sortParams.order) {
                filterObj.orderColumn = this.sortParams.prop;
                filterObj.orderType = this.sortParams.order;
            }
            let url = API.REST[this.tag];
            if (this.initialUrl) {
                url = this.initialUrl;
            }
            let datas = await doGet(url, filterObj);
            if (datas) {
                this.records = datas.records;
                this.current = datas.current;
                this.size = datas.size;
                this.total = datas.total;
            }
            if (this.afterInitialData) {
                this.afterInitialData();
            }
        },
        getModalTitle: function () {
            let title = "";
            switch (this.handle) {
                case "insert": title = "新增"; break;
                case "update": title = "修改"; break;
                case "delete": title = "删除"; break;
            }
            title += this.pageMap.find(item => item.code === this.tag).name;
            return title;
        },
        handleClick: function (handle, info) {
            this.handle = handle;
            this.isHandle = true;
            if (info) {
                this.handleInfo = JSON.parse(JSON.stringify(info));
            }
            else {
                this.handleInfo = {};
            }
            if (this.beforeHandleUpload) {  //钩子函数，专门用于对上传进行初始化操作（为了防止和用户自定义冲突）
                this.beforeHandleUpload(handle, info);
            }
            if (this.beforeHandleOpen) {    //钩子函数，打开窗口后自动触发
                this.beforeHandleOpen(handle, info);
            }
        },
        handleSubmit: async function () {
            let primaryColumn = this.pageMap.find(item => item.code === this.tag).primaryColumn;
            let resultObj;
            if (this.beforeHandleSubmit) {  //钩子函数，提交前自动触发
                this.beforeHandleSubmit();
            }
            if (this.validateSubmit && !this.validateSubmit()) {
                return;
            }
            switch (this.handle) {
                case "insert":
                    resultObj = await doPost(API.REST[this.tag], this.handleInfo);
                    break;
                case "update":
                    resultObj = await doPut(API.REST[this.tag], this.handleInfo);
                    break;
                case "delete":
                    resultObj = await doDelete(API.REST[this.tag], this.handleInfo[primaryColumn]);
                    break;
                case "show":
                    this.isHandle = false;
                    return;
                    break;
            }
            if (this.afterHandleSubmit) {  //钩子函数，提交后自动触发
                this.afterHandleSubmit();
            }
            this.showResult(resultObj);
        },
        showResult: function (resultObj) {
            if (resultObj.errorCode == 0) {
                this.$message.success(resultObj.errorMessage);
                this.isHandle = false;
                this.loadData();
            }
            else {
                this.$message.error(resultObj.errorMessage);
            }
        },
        convertToDate: function (unixTime) {
            if (unixTime) {
                const date = new Date(unixTime * 1000);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            }
            else {
                return "--";
            }
        },
        loadData: function (current) {
            if (current) {
                this.current = current;
            }
            //初始化参数
            if (this.initialParam) {
                this.initialParam();
            }
            //初始化数据
            if (this.getData) {     //若在组件/页面中存在getData方法，则执行getData方法，若不存在则执行默认的initialData方法
                this.getData();
            }
            else {
                this.initialData();
            }
            if (this.reloadData) {
                this.reloadData();
            }
        }
    },
    beforeMount: function () {
        this.loadData();
    }
}